import type { ReactNode } from 'react';
import { createContext, useState } from 'react';
import type { SupportedLanguage } from '@/i18n.ts';

type DocumentationContextType = {
  basePath: string; // absolute path for module's documentation storage
  docRoute: string; // route segment for documentation pages
  modulePath: string; // route segment for the module
  fallbackLanguage: string;
  currentLanguage: string;
  navigateFn: () => (path: string) => void;
  locationFn: () => { pathname: string };
  infoFile: string | null;
  meta: {
    filesMap: string;
    contentsMap: Record<SupportedLanguage, string>;
    infoPaneMap: Record<SupportedLanguage, Record<string, string>>;
  };
  setInfoFile: (path: string | null) => void;
};

export type DocumentationContextValue = Omit<DocumentationContextType, 'infoFile' | 'setInfoFile'>;

export const DocumentationContext = createContext<DocumentationContextType>({} as DocumentationContextType);

const DocumentationProvider = ({ children, value }: { children: ReactNode; value: DocumentationContextValue }) => {
  const [infoFile, setInfoFile] = useState<string | null>(null);

  const contextValue = {
    ...value,
    infoFile,
    setInfoFile,
  };

  return <DocumentationContext.Provider value={contextValue}>{children}</DocumentationContext.Provider>;
};

export default DocumentationProvider;
